import emailjs from '@emailjs/browser';

const {
  REACT_APP_EMAILJS_PUBLIC_KEY,
  REACT_APP_EMAILJS_SERVICE_ID,
  REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID,
  REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID,
} = process.env;

const assertEmailConfig = (templateId) => {
  if (
    !REACT_APP_EMAILJS_PUBLIC_KEY ||
    !REACT_APP_EMAILJS_SERVICE_ID ||
    !templateId
  ) {
    throw new Error(
      'Faltan variables de entorno para EmailJS. Revisa .env.local.'
    );
  }
};

export const sendContactEmail = async (payload) => {
  assertEmailConfig(REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID);

  return emailjs.send(
    REACT_APP_EMAILJS_SERVICE_ID,
    REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID,
    payload,
    REACT_APP_EMAILJS_PUBLIC_KEY
  );
};

export const sendQuoteEmail = async (payload) => {
  assertEmailConfig(REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID);

  return emailjs.send(
    REACT_APP_EMAILJS_SERVICE_ID,
    REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID,
    payload,
    REACT_APP_EMAILJS_PUBLIC_KEY
  );
};
